import { Button, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import Page from "../components/ui/Page.js";
import HelpInfo from "../features/content/components/HelpInfo.js";
import { getError } from "../features/offer/slices/offerSlice.js";

const ErrorPage = ({ title = "", message = "", error = null }) => {
  const apiError = useSelector(getError);
  const isGenericError = !title && !apiError?.title;

  const displayTitle =
    title || apiError?.title || "Oops! Something went wrong.";
  const displayMessage = isGenericError
    ? "An unexpected error occured. Our technical team is looking into it."
    : message || apiError?.message;

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/clienterror`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        title: displayTitle,
        message: displayMessage,
        error: isGenericError ? error?.message : undefined,
      }),
    }).catch(() => {});
  }, []);

  return (
    <Page title="Error" sx={{ minHeight: "stretch" }}>
      <Stack gap={2}>
        <Typography variant="h2" fontWeight="bold">
          {displayTitle}
        </Typography>
        {isGenericError ? (
          <>
            <Typography>{displayMessage}</Typography>
            <Button
              component="a"
              href="https://vayklife.com/find-your-stay"
              variant="contained"
              sx={{ alignSelf: "flex-start" }}
            >
              Find your stay
            </Button>
          </>
        ) : (
          <Typography>{displayMessage}</Typography>
        )}
        <HelpInfo />
      </Stack>
    </Page>
  );
};

ErrorPage.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  error: PropTypes.instanceOf(Error),
};

export default ErrorPage;
